
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Media } from "@/types";

@Component
export default class EventCardImage extends Vue {
  @Prop() media!: Media[];
  @Prop() image!: string;
  @Prop() small!: boolean;
}
